import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface CrudMetaColumn {
  name: string;
  dataType: string; // varchar, int, text, date, enum, etc.
  isNullable: boolean;
  isPrimaryKey: boolean;
  maxLength?: number | null;
  enumValues?: string[] | null;
  defaultValue?: any;

  // NUEVO: info FK (si aplica)
  isForeignKey?: boolean;
  refTable?: string | null;
  refColumn?: string | null; // normalmente 'id'
}

export interface CrudMeta {
  table: string;
  primaryKey: string;
  columns: CrudMetaColumn[];
}

export interface CrudListResponse {
  rows: any[];
  total: number;
}

export interface FkOption {
  id: any;
  label: string;
}

@Injectable({ providedIn: 'root' })
export class CrudService {
  private API = 'https://dashboard.voyjaleas.com/api-dashboard/crud/crud.php'; // ajusta si es necesario

  constructor(private http: HttpClient) {}

  getMeta(table: string): Observable<CrudMeta> {
    const params = new HttpParams().set('action', 'meta').set('table', table);
    return this.http.get<CrudMeta>(this.API, { params });
  }

  list(
    table: string,
    page = 1,
    pageSize = 10,
    sort = '',
    dir: 'asc' | 'desc' | '' = '',
    search = ''
  ): Observable<CrudListResponse> {
    let params = new HttpParams()
      .set('action', 'list')
      .set('table', table)
      .set('page', String(page))
      .set('pageSize', String(pageSize))
      .set('sort', sort)
      .set('dir', dir || '')
      .set('search', search || '');
    return this.http.get<CrudListResponse>(this.API, { params });
  }

  create(table: string, data: any) {
    const body = new FormData();
    body.append('action', 'create');
    body.append('table', table);
    body.append('payload', JSON.stringify(data));
    return this.http.post(this.API, body);
  }

  update(table: string, pkName: string, id: any, data: any) {
    const body = new FormData();
    body.append('action', 'update');
    body.append('table', table);
    body.append('pk', pkName);
    body.append('id', String(id));
    body.append('payload', JSON.stringify(data));
    return this.http.post(this.API, body);
  }

  remove(table: string, pkName: string, id: any) {
    const body = new FormData();
    body.append('action', 'delete');
    body.append('table', table);
    body.append('pk', pkName);
    body.append('id', String(id));
    return this.http.post(this.API, body);
  }

  getFkOptions(table: string, fkColumn: string, labelFields?: string[]) {
  let params = new HttpParams().set('action', 'fk-options').set('table', table).set('fk', fkColumn);
  if (labelFields && labelFields.length) params = params.set('label', labelFields.join(','));
  return this.http.get<{id:any,label:string,data:any}[]>(this.API, { params });
}


}
